import client from './client';
export const authAPI = {
    async register(data) {
        const response = await client.post('/auth/register', data);
        return response.data.data;
    },
    async verifyRegistration(data) {
        const response = await client.post('/auth/register/verify', data);
        return response.data.data;
    },
    async resendRegistrationCode(data) {
        const response = await client.post('/auth/register/resend', data);
        return response.data.data;
    },
    async login(data) {
        const response = await client.post('/auth/login', data);
        return response.data.data;
    },
    async forgotPassword(data) {
        const response = await client.post('/auth/password/forgot', data);
        return response.data.data;
    },
    async getMe() {
        const response = await client.get('/auth/me');
        return response.data.data;
    },
    async changePassword(data) {
        const response = await client.post('/auth/password/change', data);
        return response.data.data;
    },
    async resetTwoFactor(data) {
        const response = await client.post('/auth/2fa/reset', data);
        return response.data.data;
    },
    async getTwoFactorSetup() {
        const response = await client.get('/auth/2fa/setup');
        return response.data.data;
    },
    async verifyTwoFactorSetup(data) {
        const response = await client.post('/auth/2fa/setup/verify', data);
        return response.data.data;
    },
    async verifyTwoFactorLogin(data) {
        const response = await client.post('/auth/2fa/verify', data);
        return response.data.data;
    },
    async resendTwoFactorCode(data) {
        const response = await client.post('/auth/2fa/resend', data);
        return response.data.data;
    },
};
